import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useGetProjectsQuery } from "../features/projects/projectsApi";
import { useAddTaskMutation } from "../features/tasks/tasksApi";
import { useGetTeamQuery } from "../features/team/teamApi";

const initialState = {
  taskName: "",
  teamMember: "",
  projectName: "",
  deadline: "",
};

const AddTask = () => {
  const { data: projects } = useGetProjectsQuery();
  const { data: team } = useGetTeamQuery();
  const [addTask, { isSuccess }] = useAddTaskMutation();
  const navigate = useNavigate();

  const [formData, setFormData] = useState(initialState);

  const handleSubmit = (e) => {
    e.preventDefault();

    addTask({
      taskName: formData.taskName,
      teamMember: team?.find((member) => member.name === formData.teamMember),
      project: projects?.find(
        (project) => project.projectName === formData.projectName
      ),
      deadline: formData.deadline,
      status: "pending",
    });
  };

  useEffect(() => {
    isSuccess && navigate("/task");
  }, [isSuccess, navigate]);

  return (
    <div className="container relative">
      <main className="relative z-20 max-w-3xl mx-auto rounded-lg xl:max-w-none">
        <h1 className="mt-4 mb-8 text-3xl font-bold text-center text-gray-800">
          Create Task for Your Team
        </h1>

        <div className="justify-center mb-10 space-y-2 md:flex md:space-y-0">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="fieldContainer">
              <label htmlFor="lws-taskName">Task Name</label>
              <input
                type="text"
                name="taskName"
                id="lws-taskName"
                required
                placeholder="Implement RTK Query"
                value={formData.taskName}
                onChange={(e) =>
                  setFormData({ ...formData, taskName: e.target.value })
                }
              />
            </div>

            <div className="fieldContainer">
              <label>Assign To</label>
              <select
                name="teamMember"
                id="lws-teamMember"
                required
                value={formData.teamMember}
                onChange={(e) =>
                  setFormData({ ...formData, teamMember: e.target.value })
                }
              >
                <option value="" hidden>
                  Select Job
                </option>
                {team?.map((teamMember) => (
                  <option key={teamMember.id} value={teamMember.name}>
                    {teamMember.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="fieldContainer">
              <label htmlFor="lws-projectName">Project Name</label>
              <select
                id="lws-projectName"
                name="projectName"
                required
                value={formData.projectName}
                onChange={(e) =>
                  setFormData({ ...formData, projectName: e.target.value })
                }
              >
                <option value="" hidden>
                  Select Project
                </option>
                {projects?.map((project) => (
                  <option key={project.id} value={project.projectName}>
                    {project.projectName}
                  </option>
                ))}
              </select>
            </div>

            <div className="fieldContainer">
              <label htmlFor="lws-deadline">Deadline</label>
              <input
                type="date"
                name="deadline"
                id="lws-deadline"
                required
                value={formData.deadline}
                onChange={(e) =>
                  setFormData({ ...formData, deadline: e.target.value })
                }
              />
            </div>

            <div className="text-right">
              <button type="submit" className="lws-submit">
                Save
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddTask;
